import React, {Component} from 'react'
import {Helmet} from "react-helmet";


class ContactPage extends Component {
	state = {
		name: '',
		email: '',
		message: ''
	}

	componentWillMount() {
		document.body.className='contact'
	}

	handleSubmit = (e) => {
		e.preventDefault()
		const component = this
		if (!this.state.name || !this.state.email || !this.state.message) {
			alert("Please fill all fields")
			return
		}
		const emailPatt = new RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')
		if (!emailPatt.test(this.state.email)) {
			alert("email should match 'example@host.com' pattern")
			return
		}
		fetch('/contact', {
			method: 'post',
			headers: {
				'Accept': 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(this.state)
		}).then(function (response) {
			return response.json()
		}).then(function (data) {
			alert(data.result)
		}).catch((err) => {
			alert(err.result)
		}).finally(() => {
			component.setState({...this.state, name: '',email:'',message:''})
		})
	}

	handleChange = (e) => {
		switch (e.target.id) {
			case 'name':
				this.setState({...this.state, name: e.target.value})
				break
			case 'email':
				this.setState({...this.state, email: e.target.value})
				break
			case 'message':
				this.setState({...this.state, message: e.target.value})
				break
			default:
				break
		}
	}

	render() {
		return (
			<main>
				<Helmet>
					<title>Contact | Tokariev Sviatoslav's workshop</title>
				</Helmet>
				<h1 className="heading--contact">Contact me</h1>
				<form className="contact-form" id="contact-form" onSubmit={this.handleSubmit}>
					<div className="contact-form__group">
						<input type="text" id="name" value={this.state.name} onChange={this.handleChange} required/>
						<label htmlFor="name">NAME</label>
					</div>
					<div className="contact-form__group">
						<input type="text" id="email" value={this.state.email} onChange={this.handleChange} name="email"
						       required/>
						<label htmlFor="email">EMAIL</label>
					</div>
					<div className="contact-form__group contact-form__group--textarea">
						<textarea value={this.state.message} name="message" id="message" cols="30" rows="10" onChange={this.handleChange} required>
							</textarea>
						<label htmlFor="message">MESSAGE</label>
					</div>
					<button className="button--pink" id="sendMsg">Send message</button>
				</form>
				<p className="contact-details">
					or mail me to
					<a href="mailto:sviatoslav.tokariev@gmail.com" target="_top">sviatoslav.tokariev@gmail.com</a>
				</p>
				<div className="social">
					<h2 className="hidden">Social links</h2>
					<ul>
						<li className="social__link">
							<a href="https://github.com/svtokarevsv" target="_blank" rel="noopener noreferrer"
							   className="icon--github" title="Github" aria-label="Github link">
							</a>
						</li>
						<li className="social__link">
							<a href="https://www.facebook.com/svtokarevsv" target="_blank" rel="noopener noreferrer"
							   className="icon--facebook" title="Facebook" aria-label="Facebook link">
							</a>
						</li>
						<li className="social__link">
							<a href="https://www.linkedin.com/in/tokarievsviatoslav/" target="_blank"
							   rel="noopener noreferrer" className="icon--linkedin" title="Linkedin"
							   aria-label="Linkedin link">
							</a>
						</li>
					</ul>
				</div>
			</main>
		)
	}

}

export default ContactPage



// WEBPACK FOOTER //
// ./src/containers/ContactPage.js